import React, { Component } from "react";
import Select from "../common/Select";
import Progress from "../common/Progress";
import TimeInput from "../common/Time-input";
import Input from "../common/Input";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import spinner from "../assets/rizevoLoader.gif";
import API from "../common/Api";

const mapStateToProps = (state) => ({
  banks: state.banks,
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class PayoutSettings extends Component {
    state = {};
    resolveAccountName = () => {
      if (this.state.bank_code && this.state.account_number) {
        this.setState({ loading: true });
        const body = {
          bank_code: this.state.bank_code,
          account_number: this.state.account_number,
        };
        const loaded = () => this.setState({ loading: false });

        //  
        API.post("banks/resolve", body, { headers: this.props.headers }).then(
          ({ data }) => {
            loaded();
            if (data.data.account_name != "error") {
              this.setState({ account_name: data.data.account_name });
              this.lastCorrectAccountDetails = {
                account_number: this.state.account_number,
                bank_code: this.state.bank_code,
              };
            } else {
              this.setState({
                account_name: "Couldn't get that bank account",
              });
            }
          },
          ({ response }) => {
            loaded();
            const data = response.data;
            this.setState({ account_name: "Couldn't get that bank account" });
            if (data.errors) {
            }
          }
        );
      }
    };
    getPayOutDetails = () => {
      API.get("business/bank-accounts", {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          let mainData = data.data;
          this.setState({
            account_name: mainData.account_name,
            bank_code: mainData.bank_code,
            payout_schedule: mainData.payout_schedule,
            account_number: mainData.account_number,
            gotPayoutDetails: data.success,
          });
        },
        ({ response }) => {
          this.setState({ errorMessage: response.data.message });
        }
      );
    };
    componentDidMount = () => {
      //get payout details...
      this.getPayOutDetails();
    };
    payOutSettings = (ev) => {
      ev.preventDefault();
      this.setState({ loading: true });
      const form = ev.currentTarget;
      const body = JSON.stringify({
        bank_code: form.bank_code.value,
        payout_schedule: form.payout_schedule.value,
        account_number: form.account_number.value,
        account_name: form.account_name.value,
        bank_name: form.bank_code.options[
          form.bank_code.options.selectedIndex
        ].getAttribute("data-bank-name"),
      });
      const loaded = () => this.setState({ loading: false });

      API.post("business/bank-accounts", body, {
        headers: this.props.headers,
      }).then(
        ({ data }) => {
          loaded();
          if (data.success) {
            window.$.notify("Payout settings updated", "success-alert");
          }
        },
        ({ response }) => {
          loaded();
          if (response.data.message)
            window.$.notify(response.data.message, "error-alert");
          else window.$.notify("Something went wrong", "error-alert");
        }
      );
    };
    render() {
      return (
        <div className="onboarding-page profile-settings-page">
          <h1 className="form-title dsk">Payout settings</h1>
          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              <BackArrow />
              Payout settings
            </h1>

            <div className="form-container card">
              {this.state.gotPayoutDetails ? (
                <form onSubmit={this.payOutSettings}>

                  <Select
                    label="Payout Schedule"
                    name="payout_schedule"
                    placeholder="Select schedule"
                    onChange={(e) => {
                      this.setState({ payout_schedule: e.currentTarget.value });
                    }}
                    required
                  >
                    <option
                      value="instant"
                      selected={this.state.payout_schedule === "instant"}
                    >
                      Instant
                    </option>
                    <option
                      value="weekly"
                      selected={this.state.payout_schedule === "weekly"}
                    >
                      Weekly
                    </option>
                    <option
                      value="monthly"
                      selected={this.state.payout_schedule === "monthly"}
                    >
                      Monthly
                    </option>
                  </Select>

                  { this.state.payout_schedule === "instant" ?
                    <div className="payout-setting-schedule-notice">
                      <div className="notice-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                          <title>schedule notice</title>
                          <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                        </svg>
                      </div>
                      <p>
                        Your payout will be sent to your bank account in less than 10 minutes after each booking.
                      </p>
                    </div>
                    : null
                  }


                  { this.state.payout_schedule === "weekly" ?
                    <div className="payout-setting-schedule-notice">
                      <div className="notice-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                          <title>schedule notice</title>
                          <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                        </svg>
                      </div>
                      <p>
                        Your payouts for a week will be sent to your bank account on the Monday morning of the next week.
                      </p>
                    </div>
                    : null
                  }


                  { this.state.payout_schedule === "monthly" ?
                    <div className="payout-setting-schedule-notice">
                      <div className="notice-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                          <title>schedule notice</title>
                          <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                        </svg>
                      </div>
                      <p>
                        Your payouts for a month will be sent to your bank account on the first day of the next month.
                      </p>
                    </div>
                    : null
                  }

                  <Select
                    label="bank name"
                    name="bank_code"
                    placeholder="Select bank"
                    onChange={(e) => {
                      this.setState({ bank_code: e.currentTarget.value });
                      setTimeout(this.resolveAccountName, 0);
                    }}
                    required
                  >
                    {this.props.banks?.map((bank) => (
                      <option
                        value={bank.code}
                        data-bank-name={bank.name}
                        selected={this.state.bank_code === bank.code}
                      >
                        {bank.name}
                      </option>
                    ))}
                  </Select>
                  <Input
                    label="account number"
                    type="number"
                    name="account_number"
                    placeholder="Enter account number here"
                    onChangeAction={(value) => {
                      this.setState({ account_number: value });
                      if (value.toString().length === 10)
                        setTimeout(this.resolveAccountName, 0);
                      else {
                        this.setState({
                          account_name: "account name must be 10 numbers",
                        });
                      }
                    }}
                    defaultValue={this.state.account_number}
                    error={this.state.errors?.account_number}
                    minLength="10"
                    required
                  />
                  <div>
                    <div className="input-rapper" {...this.props}>
                      <p
                        className="label"

                      >
                        Account name
                      </p>
                      <input
                        label="account name"
                        type="text"
                        name="account_name"
                        placeholder="This field prefills"
                        value={this.state.account_name}
                        disabled
                        required
                      />
                    </div>

                    <div className="payout-setting-notice">
                      <div className="notice-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                          <title>account number notice</title>
                          <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                        </svg>
                      </div>
                      <p>
                        During payment, a different account number will be generated. 
                        However, your payout will be sent to your account automatically.
                      </p>
                    </div>

                    <div className="flex center space-btw">
                      <button
                        className={`default ${this.state.loading ? "loading" : ""
                          }`}
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              ) : this.state.errorMessage ? (
                <p>{this.state.errorMessage}</p>
              ) : (
                <img className="spinner" src={spinner} />
              )}
            </div>
          </div>
        </div>
      );
    }
  }
);
